<div class="card text-decoration-none" *ngIf="widget"
  [style.min-height.px]="widget?.minHeight">

  <div class="card-body align-items-center text m-3px">
    
    <div class="d-flex fw-bold small mb-2 text-truncate text-uppercase">
      <span class="flex-grow-1">Overdue Sites</span>
      <a class="text text-opacity-50 text-decoration-none" (click)="refresh()" data-bs-original-title="" title=""><i class="bi bi-arrow-repeat"></i></a>
    </div>

    <table class="table table-bordered table-stripped" *ngIf="overdueSites && overdueSites.length > 0; else noData">      
      <tr *ngFor="let site of overdueSites">
        <td class="text-truncate text-small" [title]="site.siteName + ' (' + site.siteUri + ')'">
          {{site.siteName}}
        </td>
        <td class="text-truncate text-end text-small">
          {{site.latestTimeStamp | relativeDate}}
        </td>
      </tr>
    </table>
    
    <ng-template #noData>
      <div class="text-center text-opacity-50 p-3" *ngIf="overdueSites && overdueSites.length == 0">
        <i class="bi bi-info-circle me-2"></i>No overdue sites found  
      </div>  
      <div class="text-center text-opacity-50 p-3" *ngIf="overdueSites == null">
        <i class="bi bi-info-circle me-2"></i>Loading...  
      </div>  
    </ng-template>

   </div>  
</div>  